export default __webpack_public_path__ + "static/media/icon-flag-red.fb1c0ce9.svg";